import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="foot-grid">
          <div className="foot-brand">
            <div className="brand">
              <img src="/assets/logo-icon.png" alt="" />
              <span>Makers Hub</span>
            </div>
            <p>
              Technologie leren op een toffe manier. Zaterdagworkshops Arduino, programmeren en
              elektronica voor kinderen 10-12.
            </p>
          </div>
          <div className="foot-col">
            <h5>Workshops</h5>
            <ul>
              <li><Link to="/workshops/simon-says">Simon Says memory-game</Link></li>
              <li><Link to="/workshops">Alle workshops</Link></li>
            </ul>
          </div>
          <div className="foot-col">
            <h5>Over</h5>
            <ul>
              <li><Link to="/over">Wie ben ik</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><a href="/#werkplaats">Community (18+)</a></li>
            </ul>
          </div>
          <div className="foot-col">
            <h5>Contact</h5>
            <ul>
              <li><Link to="/contact">Contactpagina</Link></li>
              <li><a href="mailto:hallo.contact@makershub.be">hallo.contact@makershub.be</a></li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61570829679229"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="foot-bottom">
          <span>© 2026 Makers Hub · eerste edities open</span>
        </div>
      </div>
    </footer>
  );
}
